import {Injectable} from "@angular/core";
import {Apollo, gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../store/base.graphql";
import {map, throwError} from "rxjs";
import {NotificationService} from "./notification.service";
import {Router} from "@angular/router";
import {catchError} from "rxjs/operators";

export const CITIZEN_VERIFY_PHONE_NUMBER = gql`
  mutation CitizenVerifyPhoneNumber($userPhoneNumber: String!) {
    citizenVerifyPhoneNumber(userPhoneNumber: $userPhoneNumber) {
      ${baseResponseGraphqlField}
      data {
        id
        citizenUniqueId
        citizenPhoneNumber
      }
    }
  }`


export const CITIZEN_VERIFY_OTP_NUMBER = gql`
  mutation CitizenVerifyOtpNumber($phoneNumberOtp: String!) {
    citizenVerifyOtpNumber(phoneNumberOtp: $phoneNumberOtp) {
      ${baseResponseGraphqlField}
    }
  }`

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($input: ForgotPasswordInputObject!) {
    forgotPassword(input: $input) {
      response {
        id
        status
        code
        message
      }
    }
  }`

export const CITIZEN_ACCOUNT_MOTIVATION = gql`
  mutation CitizenActivateAccountMutation($input: CitizenActivateAccountInputObject!) {
    citizenActivateAccountMutation(input: $input) {
      response {
        id
        status
        code
        message
      }
    }
  }`

export const RESET_PASSWORD = gql`
  mutation ResetPassword($input: ResetPasswordPasswordInputObject!) {
    resetPassword(input: $input) {
      response {
        id
        status
        code
        message
      }
    }
  }`

@Injectable({
  providedIn: 'root',
})

export class ForgetPassswordService {

  constructor(
    private apollo: Apollo,
    private notificationService: NotificationService,
    private router: Router,
  ) {
  }

  citizenVerifyPhoneNumber(phoneNumber: string) {
    return this.apollo.mutate({
      mutation: CITIZEN_VERIFY_PHONE_NUMBER,
      variables: {
        userPhoneNumber: phoneNumber,
      },
    }).pipe(
      map(({ data }: any) => {
        const result = data?.citizenVerifyPhoneNumber;
        if (result?.response?.status && result?.data) {
          this.notificationService.successMessage('Phone number verified successfully')
        } else {
          this.notificationService.errorMessage(result?.response?.message);
        }
      }),
      catchError((error) => {
        this.notificationService.errorMessage('An error occurred');
        console.error('Error:', error);
        return throwError(error);
      })
    );
  }

  citizenVerifyOtpNumber(phoneNumberOtp: string) {
    return this.apollo.mutate({
      mutation: FORGOT_PASSWORD,
      variables: {
        input: {
          phoneNumber:phoneNumberOtp
        }
      }
    }).pipe(
      map(({ data }: any) => {
        const result = data?.forgotPassword;
        if (result?.response?.status) {
          this.notificationService.successMessage('Phone number verified successfully')
        } else {
          // You may want to handle cases where status is false
          this.notificationService.errorMessage('Failed to verify phone number ');
        }
      })
    )
  }

  citizenVerifyEmail(email: string){
    return this.apollo.mutate({
      mutation: FORGOT_PASSWORD,
      variables: {
        input: {
          email:email,
        }
      }
    }).pipe(
      map(({ data }: any) => {
        const result = data?.forgotPassword;
        if (result?.response?.status) {
          this.notificationService.successMessage('Email Address verified successfully')
        } else {
          // You may want to handle cases where status is false
          this.notificationService.errorMessage('Failed to verify email address');
        }
      })
    )
  }

  emailResetPassword(token: string, password: string){
    return this.apollo.mutate({
      mutation: RESET_PASSWORD,
      variables: {
        input: {
          newPassword: password,
          token: token
        }
      }
    }).pipe(
      map(({ data }: any) => {
        const result = data?.resetPassword
        if (result?.response?.status) {
          this.notificationService.successMessage('Password reset successful')
        } else {
          // You may want to handle cases where status is false
          this.notificationService.errorMessage('Failed to reset password');
        }
      })
    )
  }

  citizenActivateMutation(input: {password: string, phoneNumber: string}){
    return this.apollo.mutate({
      mutation: CITIZEN_ACCOUNT_MOTIVATION,
      variables: {
        input: {
          password: input?.password,
          phoneNumber: input?.phoneNumber
        }
      }
    })
      .pipe(
        map(({ data }: any) => {
          const result = data?.citizenActivateAccountMutation
          if (result?.response?.status) {
            this.notificationService.successMessage('Password reset successful')
          } else {
            // You may want to handle cases where status is false
            this.notificationService.errorMessage('Failed to reset password');
          }
        })
      )
  }


}
